import { useScreenDetect } from '@sgcmpteltd/uikit-next';

import { ImageWithFallback } from '@/components/image-with-fallback';

import styles from './styles.module.scss';
import type { Component } from './types';

export const SimilarUsedCarItem: Component = ({
  car,
}) => {
  const {
    id,
    model,
    thumbnailUrl,
    registrationDate,
    price,
  } = car;

  const formatDate = (inputDate: string) => {
    const date = new Date(inputDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en', { month: 'short' });
    const year = 2024;

    return `${day}-${month}-${year}`;
  };

  const { isDesktop } = useScreenDetect();
  const isDesktopMode = isDesktop();

  return (
    <div className={styles.containerRoot}>
      <div className={styles.carImage}>
        <ImageWithFallback
          alt={`${id}-image`}
          className={styles.imageVehicle}
          height={isDesktopMode ? 144 : 106}
          src={thumbnailUrl}
          width={isDesktopMode ? 216 : 160} />
      </div>
      <div className={styles.carInfoContent}>
        <div className={styles.textModel}>
          {model}
        </div>
        <div className={styles.containerDataAndPrice}>
          <span>
            {formatDate(registrationDate)}
          </span>
          <span>|</span>
          <span>
            $
            {(price).toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};
